<template>
  <v-layout>
    <v-flex xs12>
      <v-container fluid grid-list-xl>
        <v-card>

          <v-stepper v-model="step">
            <v-stepper-header>
              <v-stepper-step step="1" :complete="step > 1">
                Select Type
                <small v-if="createEntity">{{createEntity | capitalize}}</small>
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="2" :complete="step > 2">
                Data Input
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="3" :complete="step > 3" :rules="[() => !this.error ]">Result</v-stepper-step>
            </v-stepper-header>
            
            <v-stepper-items>
              <v-stepper-content step="1" class="text-center">
                <p>Please choose if you want to create a new Customer or Contact.</p>
                <v-btn color="success" @click.native="chooseCreateEntity('customer')">new Customer</v-btn>
                <v-btn color="success" @click.native="chooseCreateEntity('contact')">New Contact</v-btn>
              </v-stepper-content>
              
              <v-stepper-content step="2" class="text-center">
                <p>Please fill in the form in order to create a new {{createEntity}}:</p>

                <v-form v-if="createEntity === 'customer'" v-model="valid">
                  <v-container>
                    <v-text-field
                      v-for="item in customerRequiredFields"
                      :key="item.key"
                      :label="item.key"
                      :required="true"
                      :rules="item.rules"
                      v-model="item.value"
                    ></v-text-field>

                    <v-switch
                      v-model="switchOptionals"
                      label="Show optional fields"
                    ></v-switch>          
                  </v-container>

                  <v-container v-if="switchOptionals">
                    <v-text-field
                      v-for="item in customerOptionalFields"
                      :key="item.key"
                      :label="item.key"
                      :required="false"
                      v-model="item.value"
                      placeholder='Optional'
                    ></v-text-field>              
                  </v-container>
                </v-form>

                <v-form v-if="createEntity === 'contact'" v-model="valid">
                  <v-container>
                    <v-text-field
                      v-for="item in contactRequiredFields"
                      :key="item.key"
                      :label="item.key"
                      :required="true"
                      :rules="item.rules"
                      v-model="item.value"
                    ></v-text-field>

                    <v-switch
                      v-model="switchOptionals"
                      label="Show optional fields"
                    ></v-switch>            
                  </v-container>

                  <v-container v-if="switchOptionals">
                    <v-text-field
                      v-for="item in contactOptionalFields"
                      :key="item.key"
                      :label="item.key"
                      :required="false"
                      v-model="item.value"
                      placeholder='Optional'
                    ></v-text-field>              
                  </v-container>
                </v-form>

                <p>
                  <v-btn color="success" :disabled="!valid" @click.native="create">Create</v-btn>
                </p>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-alert type="error" :value="!!error">
                  {{error}}
                </v-alert>
                <v-alert type="success" :value="!error">
                  {{createEntity | capitalize}} successfully created
                </v-alert>

                <v-data-table
                  v-if="createEntity === 'customer' && !error"
                  :headers="customerHeaders"
                  :items="updated"
                  hide-default-footer
                  class="elevation-1">
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.customerId }}</td>
                    <td>{{ props.item.customerName1 }}</td>
                    <td>{{ props.item.customerName2 }}</td>
                    <td>{{ props.item.country }}</td>
                    <td>{{ props.item.city }}</td>
                    <td>{{ props.item.zipcode }}</td>
                    <td>{{ props.item.locationCode }}</td>
                  </template>
                </v-data-table>

                <v-data-table
                  v-if="createEntity === 'contact' && !error"
                  :headers="contactHeaders"
                  :items="updated"
                  hide-default-footer
                  class="elevation-1">
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.contactId }}</td>
                    <td>{{ props.item.contactText1 }}</td>
                    <td>{{ props.item.contactText2 }}</td>
                    <td>{{ props.item.country }}</td>
                    <td>{{ props.item.city }}</td>
                    <td>{{ props.item.gepardCustomerNumber }}</td>
                    <td>{{ props.item.contactLocationCode }}</td>
                  </template>
                </v-data-table>

              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card>
      </v-container>
  </v-flex>
</v-layout>
</template>


<script>
export default {
  data() {
    let requiredFieldRules = [
      v => !!v || 'This field is required'
    ]
    let requiredNumberRules = [
      v => !!v || 'This field is required',
      v => !isNaN(v) || 'This field must be a number'
    ]
    let customerIdRules = [
      v => !!v || 'This field is required',
      v => v.length === 10 || 'This field must be 10 characters long'
    ]
    return {
      switchOptionals: false,
      valid: false,
      step: 1,
      createEntity: '',
      progress: 0,
      error: '',
      updated: [],
      customerRequiredFields: [
        {
          key: 'customerId',
          value: "",
          rules: customerIdRules
        },
        {
          key: 'customerName1',
          value: ""
        },
        {
          key: 'customerName2',
          value: ""
        },
        {
          key: 'concernName1',
          value: ""
        },
        {
          key: 'concernName2',
          value: ""
        },
        {
          key: 'ownerId',
          value: "",
          rules: requiredNumberRules
        },
        {
          key: 'locationId',
          value: "",
          rules: requiredNumberRules
        },
        {
          key: 'locationCode',
          value: "",
          rules: requiredFieldRules
        }
      ],
      customerOptionalFields: [
        {
          key: 'customerObjectType',
          value: ""
        },
        {
          key: 'concernid',
          value: ""
        },
        {
          key: 'suconId',
          value: ""
        },
        {
          key: 'subconName1',
          value: ""
        },
        {
          key: 'subconName2',
          value: ""
        },
        {
          key: 'abcIndicator',
          value: ""
        },
        {
          key: 'country',
          value: ""
        },
        {
          key: 'city',
          value: ""
        },
        {
          key: 'zipcode',
          value: ""
        },
        {
          key: 'street',
          value: ""
        },
        {
          key: 'companyType',
          value: ""
        },
        {
          key: 'concernLocationId',
          value: ""
        },
        {
          key: 'concern_location_code',
          value: ""
        },
        {
          key: 'serviceLocationCode',
          value: ""
        },
        {
          key: 'customerLockFlag',
          value: ""
        },
        {
          key: 'concernLockFlag',
          value: ""
        }
      ],
      contactRequiredFields: [
        {
          key: 'contactId',
          value: "",
          rules: requiredFieldRules
        },
        {
          key: 'customerId',
          value: "",
          rules: requiredFieldRules
        },
        {
          key: 'contactText1',
          value: ""
        },
        {
          key: 'contactText2',
          value: ""
        },
        {
          key: 'contactText3',
          value: ""
        },
        {
          key: 'country',
          value: "",
          rules: requiredFieldRules
        },
        {
          key: 'city',
          value: "",
          rules: requiredFieldRules
        },
        {
          key: 'zipcode',
          value: "",
          rules: requiredFieldRules
        },
        {
          key: 'street',
          value: "",
          rules: requiredFieldRules
        },
        {
          key: 'gepardCustomerNumber',
          value: "",
          rules: requiredFieldRules
        },
        {
          key: 'contactLocationCode',
          value: "",
          rules: requiredFieldRules
        }
      ],
      contactOptionalFields: [
        {
          key: 'contactType',
          value: ""
        },
        {
          key: 'customerObjectType',
          value: ""
        },
        {
          key: 'salesmanID',
          value: ""
        },
        {
          key: 'salesmanName',
          value: ""
        },
        {
          key: 'highloss',
          value: ""
        },
        {
          key: 'vIPFlag',
          value: ""
        },
        {
          key: 'active',
          value: ""
        },
        {
          key: 'locationId',
          value: ""
        },
        {
          key: 'contactNumber',
          value: ""
        },
        {
          key: 'aBCIndicator',
          value: ""
        },
        {
          key: 'companyGroup',
          value: ""
        },
        {
          key: 'companyStatus',
          value: ""
        },
        {
          key: 'companyType',
          value: ""
        },
        {
          key: 'serviceLocationCode',
          value: ""
        },
        {
          key: 'ownerID',
          value: ""
        }
      ],
      customerHeaders: [
        { text: 'Customer ID', sortable: false, value: 'customerId' },
        { text: 'Customer Name 1', sortable: false, value: 'customerName1' },
        { text: 'Customer Name 2', sortable: false, value: 'customerName2' },
        { text: 'Country', sortable: false, value: 'country' },
        { text: 'Zip', sortable: false, value: 'zipcode' },
        { text: 'Owner ID', sortable: false, value: 'ownerId' },
        { text: 'Location Code', sortable: false, value: 'locationCode' }
      ],
      contactHeaders: [
        { text: 'Contact ID', sortable: false, value: 'contactId' },
        { text: 'Text 1', sortable: false, value: 'contactText1' },
        { text: 'Text 2', sortable: false, value: 'contactText2' },
        { text: 'Country', sortable: false, value: 'country' },
        { text: 'City', sortable: false, value: 'city' },
        { text: 'Gepard Nr', sortable: false, value: 'gepardCustomerNumber' },
        { text: 'Location Code', sortable: false, value: 'contactLocationCode' },
      ]
    }
  },

  methods: {
    chooseCreateEntity(entity) {
      if (entity === 'customer' || entity === 'contact') {
        this.createEntity = entity
        this.step = 2
      }
    },

    create() {
      this.step = 3

      let createPromise
      let payload

      if (this.createEntity === 'customer') {
        payload = this.parseJsonPayload(this.createEntity)
        console.log(payload)
        createPromise = this.dataService.createCustomer(payload)
      } else if (this.createEntity === 'contact') {
        payload = this.parseJsonPayload(this.createEntity)
        console.log(payload)
        createPromise = this.dataService.createContact(payload)
      } else {
        createPromise = Promise.reject(
          'invalid Entity selected: ' + this.createEntity
        )
      }

      createPromise
        .then(result => {
          console.log('DONE', result)
          this.updated.push(result.data)
        })
        .catch(err => {
          console.log('ERROR')
          if (err.response) {
            // got error response from server
            console.log(+err.response.data)
            this.error =
              'Error while creating ' + this.createEntity + ': ' + err.response.data.message
          } else if (err.request) {
            // transport error
            console.log('error on creation (transport):', err)
            this.error = 'Error while sending the request'
          } else {
            // error on setup
            console.log('error on creation (setup):', err)
            this.error = 'Error while creating the create request: ' + err
          }
        })
    },

    parseJsonPayload(entityType) {
      if(entityType === "customer") {
        let result = {}
        this.customerRequiredFields.forEach(element => {
          result[element.key] = element.value
        });
        this.customerOptionalFields.forEach(element => {
          result[element.key] = element.value
        });
        return result
      } else if(entityType === "contact") {
        let result = {}
        this.contactRequiredFields.forEach(element => {
          result[element.key] = element.value
        });
        this.contactOptionalFields.forEach(element => {
          result[element.key] = element.value
        });
        return result
      } else {
        return null
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CreateContactsCustomer.vue?133682a4